import React, {useState} from "react";
import {Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";

export function SessionDropdown({onClick, list, selected, label}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen(prevState => !prevState);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret color="primary" className="dropbtn">
        {selected?.name?`${selected.name} ${selected.surname || ''}`: label}
      </DropdownToggle>
      <DropdownMenu className=" dropdown-session-content">
        {list?.map(l => (
          <DropdownItem key={l.id} onClick={() => {
            onClick(l)
          }}>
            {l.name} {l.surname || ''}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
